/******/ (() => { // webpackBootstrap
var isDefined = customElements.get('localization-form');

if (!isDefined) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.thing = 0;

      this.elements = {
        input: this.querySelector('input[name="language_code"],input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };

      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      // this.elements.button.addEventListener('blur', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }


    hidePanel() {
      this.elements.button.classList.remove('active_list');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
    openSelector() {
      if (this.elements.button.classList.contains('active_list')) { 
        this.elements.button.classList.remove('active_list'); 
        return; 
      }
      this.elements.button.focus(); 
      this.elements.button.classList.add('active_list'); 
    }

    // openSelector() {
    //   alert('openSelector');
    //   this.elements.button.focus();
    //   // this.elements.panel.toggleAttribute('hidden');
    //   this.elements.button.classList.add('active_list');
    //   // this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    // }

    // closeSelector(event) {
    //   if (this.elements.button.classList.contains('active_list')) { 
    //     this.elements.button.classList.remove('active_list'); 
    //      return; 
    //   }
    // }
  }

  customElements.define('localization-form', LocalizationForm);
}
/******/ })()
;